import { render, staticRenderFns } from "./idleModal.vue?vue&type=template&id=2d97dc73&"
import script from "./idleModal.vue?vue&type=script&lang=js&"
export * from "./idleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports